import styled from 'styled-components';
import { colors } from '../../themes/default.theme';
import { CancelPolicyAccordionHeadProps } from './gpaCancelPolicy';
import PrimaryButton from '../PrimaryButton';

interface accordionBodyProps {
  isOpen: boolean;
}

export const CancelPolicyAccordionWrap = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 2px 4px 0px #01538e33;
  margin-bottom: 20px;
  background-color: #ffffff;
`;

export const CancelPolicyAccordionHead = styled.div<
  CancelPolicyAccordionHeadProps
>`
  cursor: pointer;
  display: flex;
  height: 60px;
  align-items: stretch;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 2px 4px 0px #01538e33;

  :hover > div:first-child {
    background-color: ${colors.green1};
  }
  pointer-events: ${props => (props?.disabled ? 'none' : 'auto')};
  cursor: ${props => props?.disabled && 'not-allowed'};
  & > div:nth-child(2) > p {
    color: ${props => props?.disabled && '#979797'};
  }
  & > div:first-child {
    background-color: ${props => props?.disabled ? '#979797' : '#0072c6'};
    width: 30px;
  }
  & > * {
    cursor: ${props => props?.disabled && 'not-allowed'};
  }
`;

export const QuoteOptionsHead = styled.div<
  CancelPolicyAccordionHeadProps
>`
  display: flex;
  height: 60px;
  align-items: stretch;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 2px 4px 0px #01538e33;

  pointer-events: ${props => (props?.disabled ? 'none' : 'auto')};
  cursor: ${props => props?.disabled && 'not-allowed'};
  & > div:nth-child(2) > p {
    color: ${props => props?.disabled && '#979797'};
  }
  & > div:first-child {
    background-color: #0173c6;
    width: 30px;
  }
  & > * {
    cursor: ${props => props?.disabled && 'not-allowed'};
  }
`;

export const HeaderIconWrap = styled.div`
  display: flex;
  padding: 0 15px;
  align-items: center;
  background-color: #0072c6;
`;

export const HeaderIcon = styled.img`
  display: block;
  width: 36px;
  height: auto;
`;

export const HeaderTitleWrap = styled.div`
  display: flex;
  padding: 0 20px;
  align-items: center;
  flex-grow: 1;
`;

export const HeaderTitle = styled.p`
  flex-grow: 1;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #3b3b3b;
`;
export const HeaderTitleQuotes = styled.p`
  flex-grow: 1;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
`;

export const HeaderChevronWrap = styled.div`
  display: block;
  padding: 0 14px;
`;

export const CancelPolicyAccordionBody = styled.div<accordionBodyProps>`
  ${props => (props.isOpen ? '' : 'display: none;')}
`;

export const DisabledText = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff6e9;
  border: 1px solid #f5a524;
  border-left: 5px solid #f5a524;
  border-radius: 4px;
  color: #772f1d;
  margin: 30px;
  padding: 16px;
  font-size: 14px;
  gap: 16px;
`;

export const MessageTextBox = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 16px 12px 16px;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const OuterLeftWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const OuterLaterWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const LeftWrapper = styled.div`
  display: flex;
  width: 25%;
`;
export const LeftLaterWrapper = styled.div`
  display: flex;
`;

export const WrapperOne = styled.div`
  width: 100%;
  padding: 0.5em;
  margin: 0.5em;
`;

export const WrapperTwo = styled.div`
  width: 50%;
  padding: 0.5em;
  margin: 0.5em;
`;

export const InnerWrapperOne = styled.div`
  width: 100%;
  color: #00008b !important;
  font-weight: 700;
  padding-bottom: 7px;
`;

export const InnerWrapperTwo = styled.div`
  width: 100%;
`;

export const MainWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const MainLeftWrapper = styled.div`
  width: 100%;
`;

export const MainRightWrapper = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  text-align: center;
  padding: 4px 10px 4px 10px;
  text-transform: uppercase;
  height: 31px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
`;
export const StyledReturnButton = styled(PrimaryButton)`
  text-align: center;
  padding: 4px 10px 4px 10px;
  text-transform: uppercase;
  height: 31px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
  font-size: 15px;
`;

export const WarningIconSizing = styled.div`
  width: 50px;
  padding-right: 9px;
`;

export const StyledPrimarySummaryButton = styled(PrimaryButton)`
  text-align: center;
  background: #ffffff !important;
  color: #65a100 !important;
  border: 1px solid #65a100 !important;
  padding: 4px 10px 4px 10px;
  text-transform: uppercase;
  height: 31px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
  font-size: 15px;
`;

export const StyledPrimaryButtonWithdraw = styled(PrimaryButton)`
  text-align: center;
  background: #ffffff !important;
  color: #65a100 !important;
  border: 1px solid #65a100 !important;
  padding: 4px 10px 4px 10px;
  text-transform: uppercase;
  height: 31px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const StyledPrimaryButtonWithdrawClicked = styled(PrimaryButton)`
  text-align: center;
  padding: 4px 10px 4px 10px;
  display: flex;
  text-transform: uppercase;
  height: 31px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const LoadIcon = styled.img`
  margin: 0px 10px 0px 0px;
`;

export const LoadIconText = styled.div`
  text-transform: uppercase;
`;

export const SuccessText = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #edf2e6;
  border: 1px solid #c9dab5;
  border-left: 5px solid #4d840b;
  border-radius: 4px;
  color: #264205;
  margin: 30px 0px 30px 0px;
  padding: 16px;
  font-size: 14px;
  gap: 16px;
`;

export const ConnectButton = styled.button`
  background-color: #4d840b;
  color: #ffffff;
  border-style: none;
  border-radius: 5px;
  padding: 13px 25px 14px 25px;
  font-weight: 700;
  font-size: 19px;
  cursor: pointer;
  max-width: 252px;
`;

export const SA360Button = styled(PrimaryButton)`
    border-radius: 3px;
    padding: 8px 20px;
    width: auto;
    height: auto;
    background: rgb(77, 132, 11);
    border-radius: 5px;
    font-weight: 800;
    text-transform: uppercase;
`;
